// boombox.js - Dream Boombox with Spotify Web Playback SDK

// Suppress known Spotify cpapi errors
const originalConsoleError = console.error;
console.error = function (...args) {console.log('err');
  if (args[0] && typeof args[0] === 'string' && args[0].includes('cpapi.spotify.com')) return;
  originalConsoleError.apply(console, args);
};

let token = null;
let player = null;
let activeDeviceId = null;
let audioCtx, analyser, freqData, animationId;
let allPlaylistTrackIds;
let bReadyToPlay = false;
let currentVolume = 0.5; // Start at 50%

async function checkSpotifyAccountType(token) {
  const res = await fetch('https://api.spotify.com/v1/me', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  if (!res.ok) return 'unknown';

  const data = await res.json();
  return data.product; // "premium", "free", etc.
}

fetch(svgURL)
  .then(res => res.text())
  .then(svg => {
    document.getElementById('svgContainer').innerHTML = svg;
    setDisplayInfo('Powering up...',false);
  });

function setDisplayInfo(pText,pbScroll = false) {
  if (!pText || pText == null) return;
  let displayTextArea = document.getElementById("Track_Info_Text");
  displayTextArea.textContent = pText;
  if (pbScroll) scrollLeft();
}

function scrollLeft() {
  let displayTextArea = document.getElementById("Track_Info_Text");
  try {
    let x = parseFloat(displayTextArea.getAttribute("x"));
    x -= 0.2; // Move 1px per frame
  
    const textWidth = displayTextArea.getBBox().width;
    const leftEdge = 87;
    const rightEdge = 124;
  
    // If the text is fully out of view, reset to right side
    if (x + textWidth < leftEdge) {
      x = rightEdge;
    }
  
    displayTextArea.setAttribute("x", x);
    requestAnimationFrame(scrollLeft);
  }
  catch(e){}
}

async function getToken() {
  token = await window.spotifyAuth.getAccessToken();
  if (!token) {
    try {
      window.spotifyAuth.redirectToSpotifyLogin();
      console.log("logged in if");
    }
    catch(e){}
  }
  checkSpotifyAccountType(token).then(product => {
    if (product === 'premium') {
      console.log("premium");
      loadWebPlaybackSDK(); // your existing Web SDK init
    } else {
      //document.getElementById("embedContainer").style.visibility = "visible";
      console.log("free");
      //showSpotifyEmbed();   // your iframe fallback
    }
  });
}

function loadWebPlaybackSDK() {
  document.getElementById("svgContainer").style.display = "block";
      
  window.onSpotifyWebPlaybackSDKReady = () => {
    player = new Spotify.Player({
      name: 'Dream Boombox',
      getOAuthToken: cb => { cb(token); },
      volume: currentVolume
    });
    player.addListener('ready', ({ device_id }) => {
      setDisplayInfo('Ready to Play',false);
      bReadyToPlay = true;
      activeDeviceId = device_id;
    });
    player.addListener('player_state_changed', state => {
      if (state) {
        const track = state.track_window.current_track;
        const trackName = track.name;
        const artistName = track.artists.map(artist => artist.name).join(', ');
        setDisplayInfo(trackName,true);
        console.log('Track changed to:', trackName, 'by', artistName);
      }
    });
    player.addListener('initialization_error', ({ message }) => {
      console.error("init error="+message);
      console.log("init error="+message);
    });
    player.addListener('authentication_error', ({ message }) => {
      console.error("auth error="+message);
      console.log("auth error="+message);
    });
    player.addListener('account_error', ({ message }) => {
      console.error("account error="+message);
      console.log("account error="+message);
    });
    document.getElementById("Play_Button").addEventListener("click", () => {
      if (!bReadyToPlay) return;
      togglePlay();
    });
    document.getElementById("Prev_Button").addEventListener("click", () => {
      if (!bReadyToPlay) return;
      prevTrack();
    });
    document.getElementById("Next_Button").addEventListener("click", () => {
      if (!bReadyToPlay) return;
      nextTrack();
    });
    document.getElementById("Pause_Button").addEventListener("click", () => {
      if (!bReadyToPlay) return;
      togglePlay();
    });
    document.getElementById("Vol_Up_Button").addEventListener("click", () => {
      if (!bReadyToPlay) return;
      if (!player) return;
      currentVolume = Math.min(1.0, currentVolume + 0.1);
      player.setVolume(currentVolume).then(() => {
        console.log(`Volume increased to ${(currentVolume * 100).toFixed(0)}%`);
      });
    });
    document.getElementById("Vol_Down_Button").addEventListener("click", () => {
      if (!bReadyToPlay) return;
      if (!player) return;
      currentVolume = Math.max(0.0, currentVolume - 0.1);
      player.setVolume(currentVolume).then(() => {
        console.log(`Volume decreased to ${(currentVolume * 100).toFixed(0)}%`);
      });
    });
    document.getElementById("DREAM_Logo").addEventListener("click", () => {
      alert("Crazy sound effects!");
    });
    player.connect();
    // Enforce repeat context mode (playlist loops)
    /*setTimeout(() => {
      fetch('https://api.spotify.com/v1/me/player/repeat?state=context', {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }).catch(err => console.warn('Repeat mode set failed:', err));
    }, 1500);*/
  };
}

async function loadPlaylistTrackIds(includeUris = false) {
  const response = await fetch('https://api.spotify.com/v1/playlists/74OjLjjnlBHlLjPHXKaFks/tracks', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });

  const data = await response.json();
  const trackList = [];

  data.items.forEach(item => {
    if (item.track?.name) {
      const normalized = item.track.name.toUpperCase().replace(/[^A-Z0-9]/g, '_');
      trackList.push(includeUris ? { name: normalized, uri: item.track.uri } : normalized);
    }
  });

  return trackList;
}

function togglePlay(retries = 5)
{
  if (!player || !activeDeviceId)
  {
    console.log("No player or activeDeviceId");
    if (retries > 0)
    {
      setTimeout(() => togglePlay(retries - 1), 1000);
    }
    return;
  }

  player.getCurrentState().then(state =>
  {
    if (!state || !state.track_window || !state.track_window.current_track)
    {
      // Transfer playback and play playlist only on first play
      fetch('https://api.spotify.com/v1/me/player',
      {
        method: 'PUT',
        headers:
        {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ device_ids: [activeDeviceId], play: true })
      })
      .then(() => {
        return fetch('https://api.spotify.com/v1/me/player/play',
        {
          method: 'PUT',
          headers:
          {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ context_uri: 'spotify:playlist:74OjLjjnlBHlLjPHXKaFks' })
        });
      })
      .catch(err =>
      {
        const msg = err?.message || '';
        if (
          err?.name === 'CloudPlaybackClientError' ||
          msg.includes('PlayLoad event failed') ||
          msg.includes('cpapi.spotify.com')
        )
        {
          console.warn('Suppressed expected Spotify play error:', err);
        }
        else
        {
          console.warn('Unhandled Spotify play error:', err);
        }
      });
    }
    else if (!state.paused) {
      // If already playing, pause instead
      player.pause().catch(err => {
        const msg = err?.message || '';
        if (
          err?.name === 'CloudPlaybackClientError' ||
          msg.includes('PlayLoad event failed') ||
          msg.includes('cpapi.spotify.com')
        ) {
          console.warn('Suppressed expected Spotify pause error:', err);
        } else {
          console.warn('Unhandled Spotify pause error:', err);
        }
      });
    }
    else
    {
      // Resume without restarting playlist
      fetch('https://api.spotify.com/v1/me/player',
      {
        method: 'PUT',
        headers:
        {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ device_ids: [activeDeviceId], play: true })
      })
      .then(() => player.resume())
      .catch(err =>
      {
        const msg = err?.message || '';
        if (
          err?.name === 'CloudPlaybackClientError' ||
          msg.includes('PlayLoad event failed') ||
          msg.includes('cpapi.spotify.com')
        )
        {
          console.warn('Suppressed expected Spotify resume error:', err);
        }
        else
        {
          console.warn('Unhandled Spotify resume error:', err);
        }
      });
    }
  });   
}

async function nextTrack() {
  if (!player || !activeDeviceId) return;

  try {
    const state = await player.getCurrentState();
    const currentUri = state?.track_window?.current_track?.uri;
    const playlist = await loadPlaylistTrackIds(true);
    const currentIndex = playlist.findIndex(t => t.uri === currentUri);

    const nextIndex = (currentIndex + 1) % playlist.length;

    await fetch('https://api.spotify.com/v1/me/player/play', {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        context_uri: 'spotify:playlist:74OjLjjnlBHlLjPHXKaFks',
        offset: { position: nextIndex }
      })
    });
  } catch (err) {
    const msg = err?.message || '';
    if (
      err?.name === 'CloudPlaybackClientError' ||
      msg.includes('PlayLoad event failed') ||
      msg.includes('cpapi.spotify.com')
    ) {
      console.warn('Suppressed expected Spotify error (next):', err);
    } else {
      console.warn('Unhandled Spotify nextTrack error:', err);
    }
  }
}

function prevTrack()
{
  if (!player) return;
  try
  {
    player.previousTrack();
  }
  catch (err)
  {
    const msg = err?.message || '';
    if (
      err?.name === 'CloudPlaybackClientError' ||
      msg.includes('PlayLoad event failed') ||
      msg.includes('cpapi.spotify.com')
    )
    {
      console.warn('Suppressed expected Spotify error (previous):', err);
    }
    else
    {
      console.warn('Unhandled Spotify previousTrack error:', err);
    }
  }
}

getToken();